export enum AttackPointAttribute {
  Zone1 = 861,
  Zone2 = 862,
  Zone3 = 863,
  Zone4 = 864,
  Zone5 = 865,
  Zone6 = 866,
}
